/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ArrayLocalizationEntry,
  ArrayLocalizationEntryUpsert,
  AutomationTokenId,
  BatchUpsertSmartParametersRequest,
  GetLocalizationEntriesResponse,
  GetPublicLocalizationEntriesResponse,
  LocalizationEntry,
  LocalizationEntryCreate,
  LocalizationEntryUpdate,
  MapString,
  NonEmptySetSmartParameterValue,
  OptionWorkspaceAllowedLanguages,
  SmartParameterKey,
  SmartParametersResponse,
  TenantAllowedLanguages,
  TenantAllowedLanguagesUpdate,
  WorkspaceAllowedLanguages,
  WorkspaceAllowedLanguagesCreate,
  WorkspaceAllowedLanguagesUpdate,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "customization-settings";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns tenant allowed languages
   *
   * @tags public
   * @name GetTenantAllowedLanguages
   * @request GET:/v1/tenant/{tenantId}/tenant-allowed-languages
   * @secure
   */
  getTenantAllowedLanguages = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      TenantAllowedLanguages,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tenant-allowed-languages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getTenantAllowedLanguages */
  getTenantAllowedLanguagesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/tenant-allowed-languages`);

  /**
   * @description Update tenant allowed languages
   *
   * @tags public
   * @name UpdateTenantAllowedLanguages
   * @request POST:/v1/tenant/{tenantId}/tenant-allowed-languages/update
   * @secure
   */
  updateTenantAllowedLanguages = (
    tenantId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: TenantAllowedLanguagesUpdate,
    params: RequestParams = {},
  ) =>
    this.request<
      TenantAllowedLanguages,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tenant-allowed-languages/update`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateTenantAllowedLanguages */
  updateTenantAllowedLanguagesPathGetter = (
    tenantId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/tenant-allowed-languages/update`, query);

  /**
   * @description Returns workspace allowed languages
   *
   * @tags public
   * @name GetWorkspaceAllowedLanguages
   * @request GET:/v1/tenant/{tenantId}/{workspaceId}/workspace-allowed-languages
   * @secure
   */
  getWorkspaceAllowedLanguages = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      OptionWorkspaceAllowedLanguages,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/${workspaceId}/workspace-allowed-languages`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspaceAllowedLanguages */
  getWorkspaceAllowedLanguagesPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/${workspaceId}/workspace-allowed-languages`);

  /**
   * @description Create workspace allowed languages
   *
   * @tags public
   * @name CreateWorkspaceAllowedLanguages
   * @request POST:/v1/tenant/{tenantId}/{workspaceId}/workspace-allowed-languages/create
   * @secure
   */
  createWorkspaceAllowedLanguages = (
    tenantId: string,
    workspaceId: string,
    data: WorkspaceAllowedLanguagesCreate,
    params: RequestParams = {},
  ) =>
    this.request<
      WorkspaceAllowedLanguages,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/${workspaceId}/workspace-allowed-languages/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createWorkspaceAllowedLanguages */
  createWorkspaceAllowedLanguagesPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/${workspaceId}/workspace-allowed-languages/create`);

  /**
   * @description Update workspace allowed languages
   *
   * @tags public
   * @name UpdateWorkspaceAllowedLanguages
   * @request POST:/v1/tenant/{tenantId}/{workspaceId}/workspace-allowed-languages/update
   * @secure
   */
  updateWorkspaceAllowedLanguages = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: WorkspaceAllowedLanguagesUpdate,
    params: RequestParams = {},
  ) =>
    this.request<
      WorkspaceAllowedLanguages,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/${workspaceId}/workspace-allowed-languages/update`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWorkspaceAllowedLanguages */
  updateWorkspaceAllowedLanguagesPathGetter = (
    tenantId: string,
    workspaceId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/${workspaceId}/workspace-allowed-languages/update`, query);

  /**
   * @description Returns a list of localization set at the tenant level.
   *
   * @tags public
   * @name ListLocalizationEntriesSetAtTenantLevel
   * @request POST:/v1/tenant/{tenantId}/tenant-level/localization-entries
   * @secure
   */
  listLocalizationEntriesSetAtTenantLevel = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      GetLocalizationEntriesResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/tenant-level/localization-entries`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listLocalizationEntriesSetAtTenantLevel */
  listLocalizationEntriesSetAtTenantLevelPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/tenant-level/localization-entries`);

  /**
   * @description Returns a list of localization set at the workspace.
   *
   * @tags public
   * @name ListLocalizationEntriesSetAtWorkspaceLevel
   * @request POST:/v1/tenant/{tenantId}/{workspaceId}/localization-entries
   * @secure
   */
  listLocalizationEntriesSetAtWorkspaceLevel = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      GetLocalizationEntriesResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/${workspaceId}/localization-entries`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listLocalizationEntriesSetAtWorkspaceLevel */
  listLocalizationEntriesSetAtWorkspaceLevelPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/${workspaceId}/localization-entries`);

  /**
   * @description Returns a list of applied localization per workspace. Applied means that we check the settings of the languages allowed at the workspace level and use only the entries that are allowed.
   *
   * @tags public
   * @name ListAppliedLocalizationEntries
   * @request POST:/v1/tenant/{tenantId}/{workspaceId}/localization-entries/applied
   * @secure
   */
  listAppliedLocalizationEntries = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      GetLocalizationEntriesResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/${workspaceId}/localization-entries/applied`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listAppliedLocalizationEntries */
  listAppliedLocalizationEntriesPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/${workspaceId}/localization-entries/applied`);

  /**
   * @description Create a localization entry.
   *
   * @tags public
   * @name CreateALocalizationEntry
   * @request POST:/v1/tenant/{tenantId}/localization-entry/create
   * @deprecated
   * @secure
   */
  createALocalizationEntry = (tenantId: string, data: LocalizationEntryCreate, params: RequestParams = {}) =>
    this.request<
      LocalizationEntry,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/localization-entry/create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createALocalizationEntry */
  createALocalizationEntryPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/localization-entry/create`);

  /**
   * @description Update a localization entry.
   *
   * @tags public
   * @name UpdateALocalizationEntry
   * @request POST:/v1/tenant/{tenantId}/localization-entry/update
   * @deprecated
   * @secure
   */
  updateALocalizationEntry = (
    tenantId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
    data: LocalizationEntryUpdate,
    params: RequestParams = {},
  ) =>
    this.request<
      LocalizationEntry,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/localization-entry/update`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateALocalizationEntry */
  updateALocalizationEntryPathGetter = (
    tenantId: string,
    query: {
      /** @format int32 */
      revision: number;
    },
  ) => this.getServicePath(`/v1/tenant/${tenantId}/localization-entry/update`, query);

  /**
   * @description Batch upsert localization entries.
   *
   * @tags public
   * @name BatchUpsertLocalizationEntries
   * @request POST:/v1/tenant/{tenantId}/localization-entries/batch-upsert
   * @secure
   */
  batchUpsertLocalizationEntries = (
    tenantId: string,
    data?: ArrayLocalizationEntryUpsert,
    params: RequestParams = {},
  ) =>
    this.request<
      ArrayLocalizationEntry,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/localization-entries/batch-upsert`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for batchUpsertLocalizationEntries */
  batchUpsertLocalizationEntriesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/localization-entries/batch-upsert`);

  /**
   * @description Returns a list of applied localization per workspace. Applied means that we check the settings of the languages allowed at the workspace level and use only the entries that are allowed.
   *
   * @tags public
   * @name GuestExternalListAppliedLocalizationEntries
   * @request POST:/v1/guest-external/tenant/{tenantId}/{workspaceId}/localization-entries/applied
   * @secure
   */
  guestExternalListAppliedLocalizationEntries = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      GetPublicLocalizationEntriesResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/guest-external/tenant/${tenantId}/${workspaceId}/localization-entries/applied`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestExternalListAppliedLocalizationEntries */
  guestExternalListAppliedLocalizationEntriesPathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v1/guest-external/tenant/${tenantId}/${workspaceId}/localization-entries/applied`);

  /**
   * @description Returns a list of smart parameters for the tenant.
   *
   * @tags public
   * @name ListSmartParameters
   * @request POST:/v1/tenant/{tenantId}/smart-parameters
   * @secure
   */
  listSmartParameters = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      SmartParametersResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/smart-parameters`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSmartParameters */
  listSmartParametersPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/smart-parameters`);

  /**
   * @description Returns a list of smart parameters that match the provided values.
   *
   * @tags public
   * @name ListSmartParametersByValues
   * @request POST:/v1/tenant/{tenantId}/smart-parameters/by-values
   * @secure
   */
  listSmartParametersByValues = (tenantId: string, data: NonEmptySetSmartParameterValue, params: RequestParams = {}) =>
    this.request<
      SmartParametersResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/smart-parameters/by-values`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for listSmartParametersByValues */
  listSmartParametersByValuesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/smart-parameters/by-values`);

  /**
   * @description Batch upsert smart parameters (create or update multiple parameters at once).
   *
   * @tags public
   * @name BatchUpsertSmartParameters
   * @request POST:/v1/tenant/{tenantId}/smart-parameters/batch-upsert
   * @secure
   */
  batchUpsertSmartParameters = (
    tenantId: string,
    data: BatchUpsertSmartParametersRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      SmartParametersResponse,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/smart-parameters/batch-upsert`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for batchUpsertSmartParameters */
  batchUpsertSmartParametersPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/smart-parameters/batch-upsert`);

  /**
   * @description Delete a smart parameter.
   *
   * @tags public
   * @name DeleteASmartParameter
   * @request POST:/v1/tenant/{tenantId}/smart-parameter/delete
   * @secure
   */
  deleteASmartParameter = (tenantId: string, data: SmartParameterKey, params: RequestParams = {}) =>
    this.request<
      void,
      | AutomationTokenId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/smart-parameter/delete`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteASmartParameter */
  deleteASmartParameterPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/smart-parameter/delete`);
}
